import XboxAuthCallback from './XboxAuthCallback'
import XboxPlatformSelectBox from './XboxPlatformSelectBox'

export { XboxAuthCallback, XboxPlatformSelectBox }
